import { UseCase } from '@/core/base/use-case';
import { ReservationRepository } from '../repositories/reservation.respository';
import { Observable } from 'rxjs';
import { PersonalInformation } from '../models/personal-information.model';
import { PaymentResponse } from '../models/payment-response.model';

export class DoReservationUseCase
    implements UseCase<PersonalInformation, PaymentResponse>
{
    constructor(private readonly repository: ReservationRepository) {}

    execute(reservation: PersonalInformation): Observable<PaymentResponse> {
        return this.repository.doReservation(reservation);
    }
}
